import React,{useEffect,useCallback} from 'react';
import Button from "./button";
import CenteredDots from "./General/centeredDots";
import GeneralSVG from "./generalSVG";
import RightArrowIcon from "./icons/rightArrowIcon";
import aragLogo from '../araglogo3@2x.png';
import {
    useGoogleReCaptcha
  } from 'react-google-recaptcha-v3';
  
const ForgotPassword = (props) => {
    const { executeRecaptcha } = useGoogleReCaptcha();
      // Create an event handler so you can call the verification on button click event or form submit
      
        const handleReCaptchaVerify = useCallback(async () => {
            if (!executeRecaptcha) {
            console.log('Execute recaptcha not yet available');
            return;
            }
            const token = await executeRecaptcha('yourAction');

            // Do whatever you want with the token
            if(token){
                props.handleVerify();
            }

  }, [executeRecaptcha]);

  
  // You can use useEffect to trigger the verification as soon as the component being loaded
  useEffect(() => {
    handleReCaptchaVerify();
  },[handleReCaptchaVerify])


  const handleSubmit = async (e) => {
    e.preventDefault();

    // Perform your actions here before submitting the form
    await handleReCaptchaVerify();

    props.handleSubmit(e);
}

  
    return (
        <div>
            <div className="container ">
                <div className="row ">
                    <div className="col-lg-4 ">
                    </div>
                    <div className="col-lg-4 middle-col-lg-4 ">
                        <div className="wrapperStyle">
                            <img className="logoStyle" src={aragLogo} alt=""/>
                            <form className="formStyle" onSubmit={handleSubmit}>
                                <div className="form-group form-group-width">
                                    <label className="formTitleStyle">Reset Password</label>
                                </div>
                                <div className="form-group">
                                    <label className="control-label.text-left formGroup-textInput-label">
                                        {'Email'}
                                        <span>{' '}*</span>
                                    </label>
                                    <input type='text'
                                           required={true}
                                           className="form-control formGroup-textInput-input"
                                           name="email"
                                           value={props.email}
                                           onChange={props.handleInputChange}/>
                                </div>                                  
                                <div className="form-group">
                                    <Button
                                        customArrowStyle="setSolicitorPassword-login-arrow"
                                        btnType="submit"
                                        btnStyle={'btn btn-primary btn-xs sharp yellow btn-full-width'}
                                        label="Reset my password"/>
                                    <div className="col-sm-3">
                                    </div>
                                    <div className="col-sm-3"></div>
                                </div>
                                {props.validateMessage !== '' ?
                                    <div className="forgot-password-rejectAuthDialogBoxInfo">
                                        <div className="">{props.validateMessage}
                                        </div>
                                    </div>
                                    :
                                    null
                                }
                                {props.sendForgotPasswordSuccessMsg  ?
                                    <div className="forgot-password-successAuthDialogBoxInfo">
                                        <div className="">{props.sendForgotPasswordSuccessMsg}
                                        </div>
                                    </div>
                                    :
                                    null
                                }
                                {props.sendForgotPasswordFailedMsg  ?
                                    <div className="forgot-password-rejectAuthDialogBoxInfo">
                                        <div className="">{props.sendForgotPasswordFailedMsg}
                                        </div>
                                    </div>
                                    :
                                    null
                                }
                                <div className="form-group form-group-width no-margin-bottom" onClick={() => props.history.push('/')}>
                                    <GeneralSVG
                                        SvgWrapper="sub-heading-link inlineBlock"
                                        Label={'Back to login'}
                                        Svg={<RightArrowIcon/>}
                                    />
                                </div>
                            </form>
                            {props.sendingForgotPassword?
                                <div className="col-sm-12">
                                    <CenteredDots/>
                                </div>
                                :
                                null
                            }
                        </div>
                    </div>
                    <div className="col-lg-4 "></div>
                </div>
            </div>
        </div>
    )
};


export default ForgotPassword;
